import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ReportService } from '../../service/report.service';

@Component({
  selector: 'app-external-file-upload',
  templateUrl: './external-file-upload.component.html',
  styleUrls: ['./external-file-upload.component.scss']
})
export class ExternalFileUploadComponent implements OnInit , AfterViewInit{
  public uploadedFiles:any = null;
  public hasUploadedeFiles:boolean = false;
  public isLinkExpired:boolean = true;
  public userInfo:any;
  public iniTemplatePage: boolean = false;
  @ViewChild('expiryCard') expiryCard:ElementRef;

  constructor(public reportService: ReportService,private activateRoute:ActivatedRoute, private notifier: NotifierService) { 
    this.reportService.isFullFileUploadComponent = 'external';
  }
  
  ngOnInit(): void {
    this.openExternalFileUpload(this.activateRoute.snapshot.params['token']);
    this.reportService.externalFileUploadedEvent.subscribe((result)=> {
      this.openExternalFileUpload(result);
    })
  }
  
  
  ngAfterViewInit(): void {
  //   this.openExternalFileUpload(this.activateRoute.snapshot.params['token']);
  //   this.reportService.externalFileUploadedEvent.subscribe((result)=> {
  //     this.openExternalFileUpload(result);
  //   })
  }
  
  openExternalFileUpload(token){
      this.reportService.externalFileUploadToken = token;
      this.reportService.openExternalFileUpload({uuid:token})
      .subscribe(result => {
        this.iniTemplatePage = true;
          if(result['status'] == 2){
            this.isLinkExpired = true;
            this.userInfo = result['result'];
            this.setExpiryCardDimension();
          }
          else if(result['status'] == 1){
            this.isLinkExpired = false;
            this.userInfo = result['result'];
            this.uploadedFiles = this.userInfo && this.userInfo['uploadedFiles'] || [];
            this.setPageLayout();
          }
          else{
            this.iniTemplatePage = false;
            this.notifier.notify('error','Something went wrong.');
          }
      })
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
      this.setExpiryCardDimension();
  }

  setExpiryCardDimension(){
    if(this.expiryCard && this.expiryCard.nativeElement && this.expiryCard.nativeElement.offsetWidth<500){
      this.expiryCard.nativeElement.style.height = this.expiryCard.nativeElement.offsetWidth+'px';
    }
  }
  
  setPageLayout(){
    // document.body.style.overflow = 'hidden';
    if(this.uploadedFiles && this.uploadedFiles.length>0) this.hasUploadedeFiles = true;
    else this.hasUploadedeFiles = false;
  }

}
